import { CSS } from '@stitches/react';
import { ReactNode } from 'react';

export enum CardVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

export interface CardProps {
  children?: ReactNode;
  css?: CSS;
  variant?: CardVariants;
}
